"use client";

import React, { useState } from 'react';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';
import { _capitalizeFirstLetter } from 'helpers/Helper';
import AlgoliaSearchResults from './AlgoliaSearchResults';
import { useAppContext } from '@components/Provider';

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_CLIENT_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
);

const updateSearchIndex = (searchIndex, siteId = 1) => {
  if (searchIndex === 'articles') {
    const postIndex = `${siteId}_POST`;
    return postIndex;
  } else if (searchIndex === 'authors') {
    return 'ORM_AUTHORS';
  } else {
    return 'ORM_BOOKS';
  }
}

const SearchPage = (props) => {
  const { search, searchIndex: urlSearchIndex } = props;  
  const {siteId} = useAppContext();
  const [searchText, setSearchText] = useState(search);
  const [searchIndex, setSearchIndex] = useState(updateSearchIndex(urlSearchIndex, siteId));

  const handleSearchIndex = (key, siteId = 1, src) => {
    setSearchIndex(updateSearchIndex(key, siteId));
  };

  const future = { preserveSharedStateOnUnmount: true };

  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={searchIndex}
      stalledSearchDelay={300}
      future={future}
      initialUiState={{
        [searchIndex]: {
          query: searchText,
        },
      }}
    >
      <AlgoliaSearchResults
        searchText={searchText}
        setSearchText={setSearchText}
        searchIndex={searchIndex}
        handleSearchIndex={handleSearchIndex}
        urlSearchIndex={urlSearchIndex}
      />
      </InstantSearch>
  )
}

export default SearchPage;